document.addEventListener('variant:change', function(event) {
    let variantID = event.detail.variant.id;
    const selectElements = document.querySelectorAll('.rbr-page-container select');

    if (selectElements && selectElements.length > 0) {
        selectElements.forEach(select => {
            // Use setAttribute to update the selected value
            select.querySelectorAll('option').forEach(option => {
                if (option.value == variantID) {
                    option.setAttribute('selected', 'selected');
                } else {
                    option.removeAttribute('selected');
                }
            });

            // Trigger a change event to notify any listeners
            select.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
});

/* ------------------------------------------------------------------
   TUOTEKUVAN NAPAUTUS AVAA ZOOMIN — VAIN MOBIILI
   Lisätty 21.8.2026. Syy: Clarity ~11 700 dead clickiä/vko tuotekuvissa
   – 842 px kuva inertti, zoom vain 45 px kulmapainikkeesta.
   Desktop (grid_highlight) näyttää jo kuvakohtaiset zoom-painikkeet,
   joten sitä ei kosketa.
------------------------------------------------------------------ */
(function () {
  const MOVE_TOLERANCE = 10;  // px – erottaa napautuksen pyyhkäisystä
  const MAX_DURATION   = 600; // ms

  // Gallerian yhteinen zoom-painike = suora lapsi media-list-wrapperissa.
  // Teemassa sillä on luokka md:hidden → näkyvissä VAIN mobiilissa.
  const MOBILE_ZOOM_BUTTON =
    '.product-gallery__media-list-wrapper > .product-gallery__zoom [is="product-zoom-button"]';

  let startX = 0, startY = 0, startTime = 0;

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest('product-gallery .product-gallery__media')) return;
    startX = event.clientX;
    startY = event.clientY;
    startTime = Date.now();
  }, { passive: true });

  document.addEventListener('pointerup', function (event) {
    const media = event.target.closest('product-gallery .product-gallery__media');
    if (!media) return;

    // Älä kaappaa klikkiä jos osuttiin jo toimivaan elementtiin
    if (event.target.closest('button, a, model-viewer, video, [is="product-zoom-button"]')) return;

    // Vain kuvat – ei videot eikä 3D-mallit
    if (media.dataset.mediaType !== 'image') return;

    // Pyyhkäisy tai pitkä painallus ei saa avata zoomia
    if (Math.abs(event.clientX - startX) > MOVE_TOLERANCE) return;
    if (Math.abs(event.clientY - startY) > MOVE_TOLERANCE) return;
    if (Date.now() - startTime > MAX_DURATION) return;

    const gallery = media.closest('product-gallery');
    if (!gallery || !gallery.hasAttribute('allow-zoom')) return;

    // Mobiilirajaus: painike on olemassa mutta piilotettu md-koosta ylöspäin.
    // offsetParent === null → desktop → älä tee mitään.
    const button = gallery.querySelector(MOBILE_ZOOM_BUTTON);
    if (!button || button.offsetParent === null) return;

    event.preventDefault();
    button.click();
  }, { passive: false });
})();


/* ------------------------------------------------------------------
   PERSONOINTI – YLEISÖSIGNAALIN KERUU (women | men)
   Lisätty 17.9.2026. Lukupuoli on snippets/audience-head.liquid (head).
   Tallennus:
   - explicit: hero-CTA tai linkki, jossa data-set-audience="women|men",
     sekä pääkokoelmalinkit /collections/naisten-… ja /collections/miesten-…
   - browse: tuotesivukäynnit – 2 viimeisestä 3:sta samaa custom.gender-arvoa
     (ei yliaja explicit-valintaa)
   - localStorage vain jos Shopify Customer Privacy API sallii preferences-
     tallennuksen; muuten sessionStorage (istunnon ajan).
   Mittaus: tapahtumat lähetetään NOAudience.track-funktiolla (audience-head.liquid),
   joka hoitaa GA4:n (gtag), Shopify.analytics.publishin ja dataLayerin.
------------------------------------------------------------------ */
(function () {
  var KEY = 'no:audience', SRC = 'no:audience-src', VIEWS = 'no:gender-views';
  var MAIN_COLLECTION = /\/collections\/(naisten|miesten)-(merinovilla|uutuudet)/;

  function track(name, params) {
    if (window.NOAudience && typeof window.NOAudience.track === 'function') { window.NOAudience.track(name, params); return; }
    window.dataLayer = window.dataLayer || [];
    var d = { event: name }; for (var k in params) d[k] = params[k];
    window.dataLayer.push(d);
  }

  function consentAllowsStorage() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.preferencesProcessingAllowed === 'function') return !!cp.preferencesProcessingAllowed();
    } catch (e) {}
    return false; // API ei ladattu → ei pysyvää tallennusta
  }

  function loadPrivacyApi() {
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {}
  }

  function store(key, value) {
    try {
      if (consentAllowsStorage()) { localStorage.setItem(key, value); sessionStorage.removeItem(key); }
      else { sessionStorage.setItem(key, value); }
    } catch (e) {}
  }

  function read(key) {
    try { return localStorage.getItem(key) || sessionStorage.getItem(key) || ''; } catch (e) { return ''; }
  }

  function setAudience(value, source) {
    if (value !== 'women' && value !== 'men') return;
    var currentSrc = read(SRC);
    if (source === 'browse' && (currentSrc === 'explicit' || currentSrc === 'url')) return;
    if (read(KEY) === value && currentSrc === source) return;
    store(KEY, value);
    store(SRC, source);
    track('no_audience_set', { audience: value, audience_source: source });
    // Seuraava sivulataus näyttää personoidun sisällön; ei vaihdeta nykyistä sivua lennossa (ei CLS:ää).
  }

  window.NOAudience = window.NOAudience || {};
  window.NOAudience.set = setAudience;
  window.NOAudience.clear = function () {
    try { ['localStorage', 'sessionStorage'].forEach(function (s) { window[s].removeItem(KEY); window[s].removeItem(SRC); window[s].removeItem(VIEWS); }); } catch (e) {}
  };

  loadPrivacyApi();

  // 1) Eksplisiittiset valinnat: data-set-audience ja pääkokoelmalinkit
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-set-audience], a[href*="/collections/"]');
    if (!el) return;
    var value = el.getAttribute('data-set-audience');
    if (!value) {
      var m = MAIN_COLLECTION.exec(el.getAttribute('href') || '');
      if (m) value = m[1] === 'naisten' ? 'women' : 'men';
    }
    if (value) setAudience(value, 'explicit');
  }, { capture: true, passive: true });

  // 2) Selaussignaali tuotesivuilta
  var gender = window.NOAudience.productGender || '';
  if (gender === 'female' || gender === 'male') {
    var views = [];
    try { views = JSON.parse(read(VIEWS) || '[]'); } catch (e) { views = []; }
    views.push(gender === 'female' ? 'women' : 'men');
    views = views.slice(-3);
    store(VIEWS, JSON.stringify(views));
    var w = views.filter(function (v) { return v === 'women'; }).length;
    var m = views.length - w;
    if (views.length >= 2 && w >= 2) setAudience('women', 'browse');
    else if (views.length >= 2 && m >= 2) setAudience('men', 'browse');
  }
})();

/* ------------------------------------------------------------------
   PERSONOINTI – TUOTELISTOJEN VAIHTO (Section Rendering API)
   Lisätty 17.9.2026, välähdyksen korjaus 18.9.2026.
   featured-collection-osio merkitsee section-stackin attribuuteilla
   data-aud-url-women/men (kokoelman url) ja data-aud-section-id (osion id).
   Osion inline-skripti käynnistää haun jo jäsennysvaiheessa ja tallentaa
   lupauksen window.__noAudFetch[id]:hen; tässä käytetään sitä, jos se on
   olemassa, muuten haetaan itse. Onnistuessa section-stack vaihdetaan;
   epäonnistuessa data-aud-swap-failed paljastaa oletuslistan (CSS
   audience-head.liquidissa).
------------------------------------------------------------------ */
(function () {
  var aud = document.documentElement.getAttribute('data-audience');
  if (aud !== 'women' && aud !== 'men') return;
  var pre = window.__noAudFetch || {};
  var hosts = document.querySelectorAll('[data-aud-lazy-host][data-aud-section-id][data-aud-url-' + aud + ']');
  hosts.forEach(function (host) {
    if (host.hasAttribute('data-aud-swapped')) return;
    var url = host.getAttribute('data-aud-url-' + aud);
    var id = host.getAttribute('data-aud-section-id');
    if (!url || !id) return;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var request = pre[id] || fetch(url + sep + 'section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
    request
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-aud-lazy-host][data-aud-swapped]');
        if (!fresh) return Promise.reject('no-fresh');
        host.replaceWith(fresh);
        var params = { audience: aud, section_id: id };
        if (window.NOAudience && typeof window.NOAudience.track === 'function') window.NOAudience.track('no_audience_swap', params);
        else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'no_audience_swap', audience: aud, section_id: id }); }
      })
      .catch(function () { host.setAttribute('data-aud-swap-failed', ''); });
  });
})();
